import React from "react";
import { TableHeadersType } from "../../../constant/tableHeadersConstants/tableHeadersType";
import { formatDate } from "../../../utils/commonFunctions";
import { CircularAvatar } from "../../commons";
import { EditIcon } from "../../Icon";
import {
  grayViewIcon,
  tableEditIcon,
  tableEditWhiteIcon,
} from "../../../assets/images";
import moment from "moment";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { GetCheckInDetailDataType } from "../../../redux/mySpace/mySpaceTypes";
type AppProps = {
  tableHeader: TableHeadersType[];
  data: [] | GetCheckInDetailDataType[];
  type?: string;
  isMyCheckInsEditPresent?: boolean;
  handleEditCheckInSchedule?: (data: string) => void;
  handleCheckInFeedBackModal?: (data: string) => void;
  handleViewUsersDetails?: (data: string) => void;
};

const CheckInScheduleTableData = ({
  tableHeader,
  data,
  type,
  isMyCheckInsEditPresent,
  handleEditCheckInSchedule,
  handleCheckInFeedBackModal,
  handleViewUsersDetails,
}: AppProps) => {
  return (
    <>
      {data?.length > 0 &&
        data?.map((el: GetCheckInDetailDataType) => {
          return (
            <tr className="text-left">
              {tableHeader?.length > 0 &&
                tableHeader?.map((header: TableHeadersType) => {
                  const specifiedMoment = moment(
                    `${el?.date} ${el?.start_time}`,
                    "DD-MM-YYYY hh:mmA"
                  );
                  // Get the current date and time using moment
                  const currentMoment = moment();
                  const result = currentMoment.isAfter(specifiedMoment);
                  const isStartCheckIn =
                    type !== "MyCheckIn" &&
                    currentMoment.isAfter(
                      moment(`${el?.date} ${el?.end_time}`, "DD-MM-YYYY hh:mmA")
                    );
                  const actionButton =
                    !isStartCheckIn && !el?.feedback?.length
                      ? "Start Check-In"
                      : !el?.feedback?.length
                      ? "Submit Feedback"
                      : "View Feedback";
                  const myCheckInActionButton = !el?.feedback?.length
                    ? "Submit Feedback"
                    : "View Feedback";
                  if (header?.value === "employee_iD") {
                    return (
                      <td
                        className="text-left mt-5"
                        style={{ minWidth: "120px" }}
                      >
                        {el?.updated_by?.employee_id
                          ? el?.updated_by?.employee_id
                          : "NA"}
                      </td>
                    );
                  } else if (header?.value === "name") {
                    return (
                      <td
                        className="text-left mt-5"
                        style={{ minWidth: "200px" }}
                      >
                        <div className="d-flex">
                          <CircularAvatar
                            name={`${el?.updated_by?.first_name} ${
                              el?.updated_by?.last_name
                                ? el?.updated_by?.last_name
                                : ""
                            }`}
                            image={
                              el?.updated_by?.profile_pic &&
                              el?.updated_by.profile_pic?.file_url
                            }
                          />
                          <div className="ml-2">
                            <p
                              style={{
                                margin: "0px",
                                color: "#262a44",
                                fontWeight: "500",
                                fontSize: "14px",
                                textDecoration:
                                  type === "hrms" ? "underline" : "",
                                textUnderlineOffset:
                                  type === "hrms" ? "2px" : "",
                                cursor: type === "hrms" ? "pointer" : "default",
                              }}
                              onClick={() =>
                                type === "hrms" &&
                                handleViewUsersDetails?.(el?._id)
                              }
                            >{`${el?.updated_by?.first_name} ${
                              el?.updated_by?.last_name
                                ? el?.updated_by?.last_name
                                : ""
                            }`}</p>
                            <p
                              style={{
                                margin: "0px",
                                fontSize: "12px",
                                color: "#6e7491",
                              }}
                            >
                              {el?.updated_by?.job_title}
                            </p>
                            <p
                              style={{
                                margin: "0px",
                                fontSize: "12px",
                                color: "#6e7491",
                              }}
                            >
                              {el?.updated_by?.department}
                            </p>
                          </div>
                        </div>
                      </td>
                    );
                  } else if (header?.value === "job_location") {
                    return (
                      <td
                        className="text-left mt-5"
                        style={{ minWidth: "120px" }}
                      >
                        {el?.updated_by?.branch_name
                          ? el?.updated_by?.branch_name
                          : "NA"}
                      </td>
                    );
                  } else if (header?.value === "last_check_in_date") {
                    return (
                      <td className="text-left mt-5">
                        <p style={{ margin: "0px" }}>
                          {el?.date ? el?.date : "NA"}
                        </p>
                        <p
                          style={{
                            margin: "0px",
                            fontSize: "12px",
                            color: "#6e7491",
                          }}
                        >
                          {el?.start_time ? el?.start_time : ""}
                        </p>
                      </td>
                    );
                  } else if (header?.value === "reporting_manager") {
                    return (
                      <td
                        className="text-left mt-5 "
                        style={{ minWidth: "150px" }}
                      >
                        <div className="d-flex align-items-center">
                          <div>
                            <CircularAvatar
                              name={`${el?.manager?.first_name} ${el?.manager?.last_name}`}
                              image={
                                el?.manager?.profile_pic &&
                                el?.manager.profile_pic?.file_url
                              }
                            />
                          </div>
                          <span className="ml-2">
                            {`${el?.manager?.first_name} ${el?.manager?.last_name}`}
                          </span>
                        </div>
                      </td>
                    );
                  } else if (header?.value === "employment_status") {
                    return (
                      <td className="text-center mt-5">
                        <div
                          className={
                            el?.updated_by?.employment_status === "Full time"
                              ? `status-complete`
                              : el?.updated_by?.employment_status ===
                                "Part time"
                              ? "status-incomplete"
                              : el?.updated_by?.employment_status === "Intern"
                              ? "status-approval-pending"
                              : el?.updated_by?.employment_status ===
                                "Probation"
                              ? "manufacturing-journal"
                              : el?.updated_by?.employment_status ===
                                "Articleship"
                              ? "status-other"
                              : ""
                          }
                          style={{
                            borderRadius: "16px",
                            textAlign: "center",
                            marginTop: "5px",
                          }}
                        >
                          {el?.updated_by?.employment_status
                            ? el?.updated_by?.employment_status
                            : "NA"}
                        </div>
                      </td>
                    );
                  } else if (header?.value === "comments") {
                    return (
                      <td
                        className="text-left mt-5"
                        style={{ minWidth: "150px" }}
                      >
                        {el?.feedback?.length > 25 ? (
                          <>
                            <OverlayTrigger
                              placement="bottom"
                              delay={{ show: 250, hide: 250 }}
                              overlay={
                                <Tooltip id="button-view-filter-invoice">
                                  {el?.feedback}
                                </Tooltip>
                              }
                            >
                              <span>
                                {el?.feedback
                                  ? `${el?.feedback?.slice(0, 25)}...`
                                  : "NA"}
                              </span>
                            </OverlayTrigger>
                          </>
                        ) : el?.feedback ? (
                          el?.feedback
                        ) : (
                          "NA"
                        )}
                      </td>
                    );
                  } else if (header?.value === "comments_added_by") {
                    return (
                      <td className="text-left mt-5">
                        {el?.feedback_by?.first_name ? (
                          <div className="d-flex align-items-center">
                            <CircularAvatar
                              name={`${el?.feedback_by?.first_name} ${el?.feedback_by?.last_name}`}
                              image={
                                el?.feedback_by?.profile_pic &&
                                el?.feedback_by.profile_pic?.file_url
                              }
                            />
                            <span className="ml-2">{`${el?.feedback_by?.first_name} ${el?.feedback_by?.last_name}`}</span>
                          </div>
                        ) : (
                          "NA"
                        )}
                      </td>
                    );
                  } else if (header?.value === "action") {
                    return (
                      <>
                        {type === "MyCheckIn" ? (
                          <td
                            className="text-left mt-5"
                            style={{ minWidth: "220px" }}
                          >
                            {result && (
                              <span>
                                {" "}
                                <div>
                                  <button
                                    className={`btn w-100 ${
                                      actionButton === "View Feedback"
                                        ? "btn-outline"
                                        : "btn-primary"
                                    }`}
                                    disabled={!result}
                                    onClick={() =>
                                      handleCheckInFeedBackModal?.(el?._id)
                                    }
                                    style={{ whiteSpace: "nowrap" }}
                                  >
                                    {myCheckInActionButton}
                                  </button>
                                </div>
                              </span>
                            )}
                            <span>
                              {!result && isMyCheckInsEditPresent && (
                                <div>
                                  <button
                                    className={`btn w-100 btn-primary`}
                                    style={{ whiteSpace: "nowrap" }}
                                    onClick={() =>
                                      handleEditCheckInSchedule?.(el?._id)
                                    }
                                  >
                                    Reschedule Check-In
                                  </button>
                                </div>
                              )}
                            </span>
                          </td>
                        ) : (
                          <td className="text-start">
                            <div>
                              <button
                                className={`btn w-100 ${
                                  actionButton === "View Feedback"
                                    ? "btn-outline"
                                    : "btn-primary"
                                }`}
                                disabled={!result}
                                onClick={() =>
                                  handleCheckInFeedBackModal?.(el?._id)
                                }
                                style={{ whiteSpace: "nowrap" }}
                              >
                                {actionButton}
                              </button>
                            </div>
                          </td>
                        )}
                      </>
                    );
                  }
                })}
            </tr>
          );
        })}
    </>
  );
};

export default CheckInScheduleTableData;
